// extracted by mini-css-extract-plugin
export default {"loadingDiv":"LoadingComponent_loadingDiv__on8Ly","contentDiv":"LoadingComponent_contentDiv__blVJv"};